import React, { ChangeEvent, FormEvent, useState } from 'react';
import { Heart, Trophy, ArrowRight, ChevronDown } from 'lucide-react';
import { MembershipFormData } from '../types';
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

interface MembershipFormProps {
    visible: boolean;
    formData: MembershipFormData;
    handleInputChange: (
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAVMUOtPpzNihKe4-8XyXcjuyJl_OvU6FM",
    authDomain: "fenerbahcevizyon35.firebaseapp.com",
    projectId: "fenerbahcevizyon35",
    storageBucket: "fenerbahcevizyon35.appspot.com",
    messagingSenderId: "46588276900",
    appId: "1:46588276900:web:be94f2be8032a09300f631",
    measurementId: "G-TDK9ZEDXY6"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

const MembershipForm: React.FC<MembershipFormProps> = ({
    visible,
    formData,
    handleInputChange,
    handleSubmit,
}) => {
    const [expanded, setExpanded] = useState(false);
    if (!visible) return null;

    // New: handle Firebase submit
    const handleFirebaseSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, "membershipForms"), {
                ...formData,
                // cvFile removed
            });
            alert("Başvurunuz alındı ve kaydedildi! Fenerbahçe Vizyon 2035 ailesine hoş geldiniz!");
        } catch (error) {
            alert("Bir hata oluştu, lütfen tekrar deneyin.");
            console.error("Firestore error:", error);
        }
    };

    return (
        <form className="mt-6 sm:mt-12 w-full max-w-full" onSubmit={handleFirebaseSubmit}>
            <div className="bg-white/5 backdrop-blur-2xl rounded-2xl sm:rounded-3xl border border-white/10 p-4 sm:p-8 shadow-2xl w-full max-w-full">
                <div className="text-center mb-6 sm:mb-12">
                    <Heart className="w-8 h-8 sm:w-16 sm:h-16 text-red-500 mx-auto mb-2 sm:mb-4 animate-pulse" />
                    <h3 className="text-2xl sm:text-4xl font-bold text-white mb-2 sm:mb-4">Üyelik Formu</h3>
                    <p className="text-base sm:text-xl text-slate-300">
                        Fenerbahçe ailesinin bir parçası olmak için bilgilerinizi
                        doldurun
                    </p>
                </div>
                <div className="space-y-4 sm:space-y-6">
                    {/* Kişisel Bilgiler */}
                    {/* Kişisel Bilgiler */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
                        {[
                            { field: 'name', label: 'Ad', type: 'text', required: true },
                            { field: 'surname', label: 'Soyad', type: 'text', required: true },
                            { field: 'email', label: 'E‑posta', type: 'email', required: true },
                            { field: 'phone', label: 'Telefon', type: 'tel', required: true },
                            { field: 'birthDate', label: 'Doğum Tarihi', type: 'date', required: true },
                            { field: 'address', label: 'Adres', type: 'text', required: true },
                            { field: 'district', label: 'İlçe', type: 'text', required: true },  // new
                            { field: 'city', label: 'İl', type: 'text', required: true },         // new
                        ].map(({ field, label, type, required }) => (
                            <div key={field} className="group">
                                <label className="text-sm font-medium text-slate-300 mb-2 block">
                                    {label}{required && ' *'}
                                </label>
                                <input
                                    type={type}
                                    name={field}
                                    value={(formData as any)[field]}
                                    onChange={handleInputChange}
                                    required={required}
                                    placeholder={label}
                                    className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition"
                                />
                            </div>
                        ))}
                    </div>

                    {/* Üye No */}
                    <div className="group">
                        <label className="text-sm font-medium text-slate-300 mb-2 block">
                            Üye No *
                        </label>
                        <input
                            type="text"
                            name="memberNo"
                            value={formData.memberNo}
                            onChange={handleInputChange}
                            required
                            placeholder="Üye Numaranızı girin"
                            className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition"
                        />
                    </div>
                    {/* Toggle Button */}
                    <button
                        type="button"
                        className={`w-full flex items-center justify-center gap-2 py-2 mt-2 rounded-xl bg-gradient-to-r from-yellow-400 to-yellow-600 text-slate-900 font-semibold shadow-md hover:from-yellow-500 hover:to-yellow-700 transition-all duration-300 group ${expanded ? 'ring-2 ring-yellow-400/50' : ''}`}
                        onClick={() => setExpanded((prev) => !prev)}
                        aria-expanded={expanded}
                    >
                        <span>{expanded ? 'Daha azını gör' : 'Daha fazlasını gör'}</span>
                        <ChevronDown
                            className={`w-5 h-5 transition-transform duration-300 ${expanded ? 'rotate-180' : 'rotate-0'}`}
                        />
                    </button>
                    {/* Animated Expand/Collapse Section */}
                    <div
                        className={`transition-all duration-500 overflow-hidden ${expanded ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0 pointer-events-none'}`}
                    >
                        {/* Hidden/Expanded Section */}
                        {/* Eğitim Durumu */}
                        <h4 className="text-lg font-semibold text-white mt-6">
                            Eğitim Durunuz
                        </h4>
                        <div className="grid md:grid-cols-2 gap-6">
                            <div className="group">
                                <label className="text-sm font-medium text-slate-300 mb-2 block">
                                    Mezun Olunan Üniversite *
                                </label>
                                <input
                                    type="text"
                                    name="university"
                                    value={formData.university}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Üniversite adı"
                                    className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition"
                                />
                            </div>
                            <div className="group">
                                <label className="text-sm font-medium text-slate-300 mb-2 block">
                                    Bölüm *
                                </label>
                                <input
                                    type="text"
                                    name="department"
                                    value={formData.department}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Bölüm"
                                    className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition"
                                />
                            </div>
                            <div className="group">
                                <label className="text-sm font-medium text-slate-300 mb-2 block">
                                    Mezuniyet Yılı *
                                </label>
                                <input
                                    type="number"
                                    name="graduationYear"
                                    value={formData.graduationYear}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="YYYY"
                                    className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition"
                                />
                            </div>
                        </div>
                        <div className="group">
                            <label className="text-sm font-medium text-slate-300 mb-2 block">
                                Ek Eğitimler / Sertifikalar
                            </label>
                            <textarea
                                name="certifications"
                                value={formData.certifications}
                                onChange={handleInputChange}
                                rows={3}
                                placeholder="Varsa ek eğitim ve sertifikalarınız"
                                className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition resize-none"
                            />
                        </div>
                        {/* Uzmanlık Alanlarınız */}
                        <div className="group">
                            <p className="text-sm font-medium text-slate-300 mb-2">
                                Uzmanlık Alanlarınız *
                            </p>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                                {[
                                    'Spor Yönetimi',
                                    'Veri Analitiği / Yapay Zekâ',
                                    'İletişim / Medya / Tasarım / Reklam',
                                    'Sosyoloji / Psikoloji',
                                    'Çevre / Sürdürülebilirlik',
                                    'Girişimcilik / İnovasyon',
                                    'Hukuk',
                                    'Eğitim',
                                    'Diğer',
                                ].map((opt) => (
                                    <label key={opt} className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            name="expertise"
                                            value={opt}
                                            checked={formData.expertise.includes(opt)}
                                            onChange={handleInputChange}
                                            className="w-4 h-4 text-yellow-400 bg-white/5 border-white/20 rounded focus:ring-yellow-400"
                                        />
                                        <span className="text-slate-300 text-sm">{opt}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                        {/* Başvuru Nedeni */}
                        <div className="group">
                            <label className="text-sm font-medium text-slate-300 mb-2 block">
                                Fenerbahçe Vizyon 2035 üyeliğine neden başvuruyorsunuz?
                                <span className="text-xs text-slate-400 ml-2">(max 300 kelime)</span>
                            </label>
                            <textarea
                                name="applicationReason"
                                value={formData.applicationReason}
                                onChange={handleInputChange}
                                rows={5}
                                maxLength={2000}
                                required
                                placeholder="Neden başvuruyorsunuz?"
                                className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition resize-none"
                            />
                        </div>
                        {/* Fikir / Öneri */}
                        <div className="group">
                            <label className="text-sm font-medium text-slate-300 mb-2 block">
                                Bir fikir / öneriniz var mı? (İsteğe bağlı)
                            </label>
                            <textarea
                                name="suggestion"
                                value={formData.suggestion}
                                onChange={handleInputChange}
                                rows={4}
                                placeholder="Kısa vizyon cümlenizi yazın"
                                className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition resize-none"
                            />
                        </div>
                        {/* Katkı Sağlayabileceğiniz Konular */}
                        <div className="group">
                            <label className="text-sm font-medium text-slate-300 mb-2 block">
                                Çalışmalara hangi konularda nasıl katkı sağlayabilirsiniz?
                            </label>
                            <textarea
                                name="contributions"
                                value={formData.contributions}
                                onChange={handleInputChange}
                                rows={4}
                                required
                                placeholder="Katkı planınızı anlatın"
                                className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition resize-none"
                            />
                        </div>
                        {/* Ekler */}
                        <div className="space-y-4">
                            {/* CV file input removed */}
                            <div className="group">
                                <label className="text-sm font-medium text-slate-300 mb-2 block">
                                    Projelerinizin linkleri (varsa)
                                </label>
                                <input
                                    type="url"
                                    name="projectLinks"
                                    value={formData.projectLinks}
                                    onChange={handleInputChange}
                                    placeholder="https://…"
                                    className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition"
                                />
                            </div>
                            <div className="group">
                                <label className="text-sm font-medium text-slate-300 mb-2 block">
                                    Linkedin / Kişisel web sitesi (varsa)
                                </label>
                                <input
                                    type="url"
                                    name="personalSite"
                                    value={formData.personalSite}
                                    onChange={handleInputChange}
                                    placeholder="https://…"
                                    className="w-full px-4 py-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl text-white placeholder-slate-400 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/20 transition"
                                />
                            </div>
                        </div>
                        {/* Submit */}
                        <button
                            type="submit"
                            className="w-full mt-4 py-4 font-bold text-lg rounded-3xl bg-gradient-to-r from-yellow-400 to-yellow-600 text-slate-900 hover:from-yellow-500 hover:to-yellow-700 transform hover:scale-105 transition shadow-2xl shadow-yellow-400/25 flex items-center justify-center"
                        >
                            <Trophy className="w-5 h-5" />
                            <span>Üyelik Başvurusu Yap</span>
                            <ArrowRight className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default MembershipForm; 